export default __webpack_public_path__ + "static/media/ic-arrow-blue.833da2f7.svg";